import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import SellerActions from '@Actions/sellerActions';
import './style.scss';
import { Select } from 'antd';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import Helpers from '@Apis/helpers';
import PRZSelect from '../../../../Common/UI/PRZSelect';

/**
 *
 */
const SendVendorMail = ({
  sendAccountStatementMail, callback, user, sendAccountStatementMailLoading, startDateMomentEpoch, endDateMomentEpoch,
  selectedSeller, customerId,
}) => {
  const [toAddresses, setToAddresses] = useState([]);
  const [invalidToAddress, setInvalidToAddress] = useState(false);
  const [ccAddresses, setCcAddresses] = useState([]);
  const [invalidCcAddress, setInvalidCcAddress] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);

  useEffect(() => {
    if (selectedSeller?.seller_info?.email_id_1) {
      setToAddresses([selectedSeller?.seller_info?.email_id_1]);
    }
  }, []);

  /**
   *
   */
  const sendEmail = () => {
    setFormSubmitted(true);
    const payload = {
      to_emails: toAddresses,
      tenant_id: user?.tenant_info?.tenant_id,
      seller_id: selectedSeller?.seller_id,
      customer_id: customerId,
      cc_emails: ccAddresses,
      from: startDateMomentEpoch / 1000,
      to: Math.floor(endDateMomentEpoch / 1000),
      user_id: user?.user_id,
    };
    let allEmailsValid = true;
    for (let i = 0; i < toAddresses?.length; i++) {
      if (!Helpers.validateEmail(toAddresses[i])) {
        allEmailsValid = false;
        setInvalidToAddress(true);
        break;
      }
    }
    for (let i = 0; i < ccAddresses?.length; i++) {
      if (!Helpers.validateEmail(ccAddresses[i])) {
        allEmailsValid = false;
        setInvalidCcAddress(true);
        break;
      }
    }
    if (payload?.to_emails?.length && allEmailsValid && !invalidToAddress && !invalidCcAddress) {
      sendAccountStatementMail(payload, () => {
        callback();
      });
    }
  };

  /**
     * @param event
     * @param e
     * @param value
     */
  return (
    <div className="vendor-mail__wrapper">
      <div className="ant-row">
        <div className="ant-col-md-24">
          <div className="orgInputContainer">
            <label className="orgFormLabel">
              Recipient Email Addresses
              <span style={{ color: 'red', marginLeft: '5px' }}>*</span>
            </label>
            <PRZSelect
              mode="tags"
              value={toAddresses}
              filterOption={false}
              onChange={(value) => {
                for (let i = 0; i < toAddresses?.length; i++) {
                  if (!Helpers.validateEmail(toAddresses[i])) {
                    setInvalidToAddress(false);
                    break;
                  }
                }
                setToAddresses(value);
              }}
              disabled={sendAccountStatementMailLoading}
              showError={(formSubmitted && !toAddresses?.length) || (formSubmitted && invalidToAddress)}
              errorName={(formSubmitted && !toAddresses?.length) ? "/ enter at least one recipient" : "/ enter valid email addresses"}
              errorClassName="formError"
            />
          </div>
        </div>
        <div className="ant-col-md-24">
          <div className="orgInputContainer">
            <label className="orgFormLabel">
              CC Email Addresses
            </label>
            <PRZSelect
              mode="tags"
              value={ccAddresses}
              filterOption={false}
              onChange={(value) => {
                if (value?.length) {
                  for (let i = 0; i < ccAddresses?.length; i++) {
                    if (!Helpers.validateEmail(ccAddresses[i])) {
                      setInvalidCcAddress(true);
                      break;
                    }
                  }
                } else {
                  setInvalidCcAddress(false);
                }
                setCcAddresses(value);
              }}
              disabled={sendAccountStatementMailLoading}
              showError={formSubmitted && invalidCcAddress}
              errorName="/ enter valid email addresses"
              errorClassName="formError"
            />
          </div>
        </div>
      </div>
      <div className="custom-drawer__footer">
        <div className="ant-col-md-6">
          <H3Button
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            text="Send Email"
            onClick={() => sendEmail()}
            isLoading={sendAccountStatementMailLoading}
            disabled={sendAccountStatementMailLoading}
            style={{
              width: '160px',
              borderRadius: '5px',
              padding: '7px 0px',
              marginLeft: '0',
            }}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ SellerReducers, UserReducers }) => ({
  sendAccountStatementMailLoading: SellerReducers.sendAccountStatementMailLoading,
  user: UserReducers.user,
  selectedSeller: SellerReducers.selectedSeller,

});

const mapDispatchToProps = (dispatch) => ({
  sendAccountStatementMail: (payload, callback) => dispatch(SellerActions.sendAccountStatementMail(payload, callback)),
});

SendVendorMail.propTypes = {
  selectedSeller: PropTypes.any,
  sendAccountStatementMail: PropTypes.func,
  callback: PropTypes.func,
  user: PropTypes.any,
  sendAccountStatementMailLoading: PropTypes.bool,
  startDateMomentEpoch: PropTypes.any,
  endDateMomentEpoch: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SendVendorMail));
